import angular from 'angular';
import gridButtons from './gridButtons.html';
import './gridButtons.scss';

/*******************************************************************************
* @ngdoc component
* @name  csm.books.InitialSetup.dom.component:gridButtons
* @param {expr}    addAction       Add button click action.
* @param {expr}    changeAction    Change button click action.
* @param {expr}    removeAction    Remove button click action.
* @param {boolean} disableChanges  Disable Change/Remove flag.
* @param {number}  gridTotal       Grid total amount.
* @param {boolean} hideTotal       Hide grid total flag.
*
* @description
* Buttons and total under grid. Total is flush right with buttons flush left.
* Optional transcluded content end of template to allow flush right button.
*******************************************************************************/
export const gridButtonsComponent = {
  bindings: {
    addAction: '&',
    changeAction: '&',
    removeAction: '&',
    disableChanges: '<',
    gridTotal: '<',
    hideTotal: '<'
  },
  template: gridButtons,
  transclude: true,
  controller: angular.noop
};
